export default "__VITE_ASSET__CaaZARSd__"